import { render, staticRenderFns } from "./reviewe.vue?vue&type=template&id=12f9ea22&scoped=true"
import script from "./reviewe.vue?vue&type=script&lang=js"
export * from "./reviewe.vue?vue&type=script&lang=js"
import style0 from "./reviewe.vue?vue&type=style&index=0&id=12f9ea22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f9ea22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12f9ea22')) {
      api.createRecord('12f9ea22', component.options)
    } else {
      api.reload('12f9ea22', component.options)
    }
    module.hot.accept("./reviewe.vue?vue&type=template&id=12f9ea22&scoped=true", function () {
      api.rerender('12f9ea22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/withdraw/reviewe.vue"
export default component.exports